import React from "react";
import cn from "classnames";
import * as styles from "./styles.module.scss";

/** ============================================================================
 * @component
 * Sets max width of children. Also prodvides global padding.
 */

const WidthContainer = ({ children, paddingOnly, noFullHeight, className }) => (
  <div
    className={cn(styles.padding, className, {
      [styles.container]: !paddingOnly,
      [styles.fullHeight]: !noFullHeight
    })}
  >
    {children}
  </div>
);

export default WidthContainer;
